export const DissertationStatuses = {
  DEPARTMENT_REVIEW: 100,
  SEMINAR_REVIEW: 200,
  COUNCIL_ACCEPTED: 300,
  DEFENDED: 400,
  APPROVED: 500,
}

export const DissertationStatusList = [
  {
    id: DissertationStatuses.DEPARTMENT_REVIEW,
    uz: "Kafedra (tarkibiy bo'lim) muhokamasidan o'tgan",
    ru: 'Прошел обсуждение на кафедре (структурном подразделении)',
    en: 'Passed the department (structural unit) review',
  },
  {
    id: DissertationStatuses.SEMINAR_REVIEW,
    uz: 'Ilmiy seminarda dastlabki ekspertizadan o‘tgan',
    ru: 'Прошел предварительную экспертизу на научном семинаре',
    en: 'Passed preliminary review at the scientific seminar',
  },
  {
    id: DissertationStatuses.COUNCIL_ACCEPTED,
    uz: 'Ilmiy Kengashga himoyaga qabul qilingan',
    ru: 'Принят к защите в Научный Совет',
    en: 'Accepted for defense at the Scientific Council',
  },
  {
    id: DissertationStatuses.DEFENDED,
    uz: 'Himoya qilgan',
    ru: 'Защитил',
    en: 'Defended',
  },
  {
    id: DissertationStatuses.APPROVED,
    uz: 'Ilmiy darajada tasdiqlangan',
    ru: 'Утвержден в ученой степени',
    en: 'Approved for scientific degree',
  },
]
